import Vue from "vue";
import App from "./App.vue";

import store from "./store";
import router from "./router";

import i18n from "./plugins/i18n";
import { api } from "./plugins/api";
import "./plugins/element-ui.js";
import "./plugins/route.js";
import utils from "./plugins/utils";
import "./plugins/global-components.js";
import "./plugins/directive.js";

import "@/styles/index.scss"; // global css
import "./plugins/permission";

Vue.config.productionTip = false;

if (process.env.NODE_ENV === "development" && process.env.VUE_APP_ENV == "development") {
  const { mockXHR } = require("../mock");
  mockXHR();
}

new Vue({
  el: "#app",
  utils,
  router,
  store,
  i18n,
  api,
  render: (h) => h(App),
});
